import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

import BaseBanner from "@/components_v2/Banner/BaseBanner";
import {
  BUTTON_SIZES,
  BUTTON_VARIANTS,
} from "@/components_v2/Button/constants";

import { useCookieConsent } from "./useCookieConsent";

const CookieConsentBanner = () => {
  const { t } = useTranslation();
  const { isVisible, accept, reject, isSubmitting } = useCookieConsent();

  if (!isVisible) return null;

  return (
    <BaseBanner
      vertical
      title={t("consent.title")}
      description={
        <>
          {t("consent.description")}
          <Link
            to="/privacy-policy"
            style={{
              display: "block",
              marginTop: 4,
              textDecoration: "underline",
            }}
          >
            {t("consent.learnMore")}
          </Link>
        </>
      }
      backgroundColor="var(--base-white)"
      style={{
        position: "fixed",
        right: 16,
        bottom: 16,
        maxWidth: 480,
        zIndex: 1000,
        boxShadow: "0 4px 16px rgba(0, 0, 0, 0.12)",
        borderRadius: 8,
      }}
      buttons={[
        {
          size: BUTTON_SIZES.SMALL,
          variant: BUTTON_VARIANTS.SECONDARY,
          onClick: reject,
          disabled: isSubmitting,
          children: t("consent.reject"),
        },
        {
          size: BUTTON_SIZES.SMALL,
          variant: BUTTON_VARIANTS.PRIMARY,
          onClick: accept,
          loading: isSubmitting,
          children: t("consent.accept"),
        },
      ]}
    />
  );
};

export default CookieConsentBanner;
